export default __webpack_public_path__ + "static/media/Traffic.e9e2eb8a.png";